/**
 * バース予約ステータスの設定
 */
export const BERTH_RESERVATION_STATUS_CONFIG = {
  not_required: { label: '不要', color: 'default' as const },
  not_reserved: { label: '未予約', color: 'error' as const },
  partial: { label: '一部予約', color: 'warning' as const },
  reserved: { label: '予約済', color: 'success' as const },
  unknown: { label: '不明', color: 'default' as const },
} as const;

export type BerthReservationStatus = keyof typeof BERTH_RESERVATION_STATUS_CONFIG;
